import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/db91mfbk13ra8mig9080";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("contact_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    formData.delete("contact_alt");

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, String(value));
    });

    setStatus("loading");
    setErrorMsg("");

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setErrorMsg(
          isSpam
            ? "提交内容被判定为无效，请修改后重试。"
            : serverMsg || "提交失败，请稍后重试。"
        );
      }
    } catch {
      setStatus("error");
      setErrorMsg("网络异常，请稍后重试。");
    }
  };

  const inputClass =
    "w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400/60";

  return (
    <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col gap-4" noValidate>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-xs text-foreground-600 mb-1.5 font-label">
            您的称呼
          </label>
          <input id="contact-name" name="name" type="text" required placeholder="请输入称呼" className={inputClass} />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-xs text-foreground-600 mb-1.5 font-label">
            邮箱地址
          </label>
          <input id="contact-email" name="email" type="email" required placeholder="name@example.com" className={inputClass} />
        </div>
      </div>
      <div>
        <label htmlFor="contact-subject" className="block text-xs text-foreground-600 mb-1.5 font-label">
          反馈主题
        </label>
        <input id="contact-subject" name="subject" type="text" placeholder="例如：内容纠错 / 合作建议" className={inputClass} />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-xs text-foreground-600 mb-1.5 font-label">
          反馈内容
        </label>
        <textarea
          id="contact-message"
          name="message"
          rows={4}
          required
          maxLength={500}
          placeholder="请描述您的建议或想反馈的问题（500 字以内）"
          className={`${inputClass} resize-none`}
        ></textarea>
      </div>

      <input
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-anti-bot-field"
      />

      <button
        type="submit"
        disabled={status === "loading"}
        className="self-start px-6 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-label font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {status === "loading" ? "提交中..." : "提交反馈"}
      </button>

      {status === "success" && (
        <p className="text-sm text-primary-700 bg-primary-100 rounded-md px-3 py-2">
          提交成功，感谢你的反馈，我们会尽快查看并回复。
        </p>
      )}
      {status === "error" && (
        <p className="text-sm text-accent-700 bg-accent-100 rounded-md px-3 py-2">{errorMsg}</p>
      )}
    </form>
  );
}